import { atom } from "recoil";

export const organizationDataState = atom({
    key: "organizationDataState",
    default: [],
});
